export default function CsharpForeach() {
  return (
    <h2>Csharp Foreach</h2>
  );
}
